define('@outsystems/virtualized-list', ['exports', 'react', 'react-transition-group', 'react-dom'], function (exports, React, reactTransitionGroup, ReactDOM) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) {
            Object.keys(e).forEach(function (k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function () {
                            return e[k];
                        }
                    });
                }
            });
        }
        n['default'] = e;
        return Object.freeze(n);
    }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var React__namespace = /*#__PURE__*/_interopNamespace(React);
    var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);

    exports.ScrollExtensions = void 0;
    (function (ScrollExtensions) {
        var OVERFLOW_REGEX = /(auto|scroll)/;
        var NON_SCROLLABLE_ELEMENT_ATRIBUTE = "data-not-scrollable";
        var ScrollDirection;
        (function (ScrollDirection) {
            ScrollDirection[ScrollDirection["Horizontal"] = 0] = "Horizontal";
            ScrollDirection[ScrollDirection["Vertical"] = 1] = "Vertical";
            ScrollDirection[ScrollDirection["None"] = 2] = "None";
        })(ScrollDirection = ScrollExtensions.ScrollDirection || (ScrollExtensions.ScrollDirection = {}));
        function getScrollHostInfo(element, excludeStaticParent) {
            if (element === null || element === undefined || element instanceof Document) {
                return {
                    scrollHost: window,
                    scrollDirection: ScrollDirection.Vertical,
                };
            }
            var elementComputedStyle = getComputedStyle(element);
            excludeStaticParent = excludeStaticParent || elementComputedStyle.position === "absolute";
            if (!excludeStaticParent || elementComputedStyle.position !== "static") {
                var isOverFlow = OVERFLOW_REGEX.test(elementComputedStyle.overflow + elementComputedStyle.overflowY + elementComputedStyle.overflowX);
                if (isOverFlow) {
                    if (!element.hasAttribute(NON_SCROLLABLE_ELEMENT_ATRIBUTE)) {
                        return {
                            scrollHost: element === document.documentElement ? window : element,
                            scrollDirection: OVERFLOW_REGEX.test(elementComputedStyle.overflowY)
                                ? ScrollDirection.Vertical
                                : ScrollDirection.Horizontal,
                        };
                    }
                }
            }
            return getScrollHostInfo(element.parentElement, excludeStaticParent);
        }
        ScrollExtensions.getScrollHostInfo = getScrollHostInfo;
        function getScrollInfo(scrollHost) {
            if (scrollHost instanceof Window) {
                return {
                    scrollHost: scrollHost,
                    scroll: {
                        x: document.documentElement.scrollLeft,
                        y: document.documentElement.scrollTop,
                        height: document.documentElement.scrollHeight,
                        width: document.documentElement.scrollWidth,
                    },
                    viewport: {
                        x: 0,
                        y: 0,
                        height: scrollHost.innerHeight,
                        width: scrollHost.innerWidth,
                    },
                };
            }
            else if (scrollHost instanceof HTMLElement) {
                return {
                    scrollHost: scrollHost,
                    scroll: {
                        x: scrollHost.scrollLeft,
                        y: scrollHost.scrollTop,
                        height: scrollHost.scrollHeight,
                        width: scrollHost.scrollWidth,
                    },
                    viewport: {
                        x: 0,
                        y: 0,
                        height: scrollHost.clientHeight,
                        width: scrollHost.clientWidth,
                    },
                };
            }
            return null;
        }
        ScrollExtensions.getScrollInfo = getScrollInfo;
        function setScrollOffset(scrollHost, x, y, increment) {
            if (increment === void 0) { increment = false; }
            if (scrollHost instanceof Window) {
                scrollHost = document.body;
            }
            var scrollHostElement = scrollHost;
            if (y && !isNaN(y)) {
                if (increment) {
                    y += scrollHostElement.scrollTop;
                }
                scrollHostElement.scrollTop = y;
            }
            if (x && !isNaN(x)) {
                if (increment) {
                    x += scrollHostElement.scrollLeft;
                }
                scrollHostElement.scrollLeft = x;
            }
        }
        ScrollExtensions.setScrollOffset = setScrollOffset;
    })(exports.ScrollExtensions || (exports.ScrollExtensions = {}));
    exports.ObjectExtensions = void 0;
    (function (ObjectExtensions) {
        function assign(target) {
            var sources = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                sources[_i - 1] = arguments[_i];
            }
            if (target == null) {
                throw new TypeError("Cannot convert undefined or null to object");
            }
            target = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source != null) {
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
            }
            return target;
        }
        ObjectExtensions.assign = assign;
    })(exports.ObjectExtensions || (exports.ObjectExtensions = {}));

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    var TIMEOUT_ENTER = 17;
    var TIMEOUT_EXIT = 17;
    var AnimatedGroup = (function (_super) {
        __extends(AnimatedGroup, _super);
        function AnimatedGroup() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AnimatedGroup.prototype.getAnimatedItem = function () {
            return AnimatedItem;
        };
        AnimatedGroup.prototype.render = function () {
            var _this = this;
            var AnimatedComponent = this.getAnimatedItem();
            var suspendAnimations = this.props.shouldSuspendAnimations
                ? this.props.shouldSuspendAnimations()
                : false;
            var transitionClassNames = {
                appear: this.props.transitionName + "-appear",
                appearActive: this.props.transitionName + "-appear-active",
                appearDone: this.props.transitionName + "-appear-done",
                enter: this.props.transitionName + "-enter",
                enterActive: this.props.transitionName + "-enter-active",
                enterDone: this.props.transitionName + "-enter-done",
                exit: this.props.transitionName + "-leave",
                exitActive: this.props.transitionName + "-leave-active",
                exitDone: this.props.transitionName + "-leave-done",
            };
            var animatedItems = React__default['default'].Children.map(this.props.children, function (child) { return (React__default['default'].createElement(AnimatedComponent, { enter: !suspendAnimations, exit: !suspendAnimations, classNames: transitionClassNames, onEnter: _this.props.onEnter, onEntering: _this.props.onEnterStarted, onExit: _this.props.onLeave, onExiting: _this.props.onLeaveStarted, key: child.key, timeout: { enter: TIMEOUT_ENTER, exit: TIMEOUT_EXIT } }, child)); });
            return (React__default['default'].createElement(reactTransitionGroup.TransitionGroup, { component: this.props.component, className: this.props.className }, animatedItems));
        };
        return AnimatedGroup;
    }(React__default['default'].Component));
    var AnimatedItem = (function (_super) {
        __extends(AnimatedItem, _super);
        function AnimatedItem() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AnimatedItem.prototype.render = function () {
            return React__default['default'].createElement(reactTransitionGroup.CSSTransition, __assign({}, this.props));
        };
        return AnimatedItem;
    }(React__default['default'].Component));

    var PIXELS_UNIT = "px";
    var AnimatedSizeGroup = (function (_super) {
        __extends(AnimatedSizeGroup, _super);
        function AnimatedSizeGroup() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AnimatedSizeGroup.prototype.getAnimatedItem = function () {
            return AnimatedSizeItem;
        };
        return AnimatedSizeGroup;
    }(AnimatedGroup));
    var AnimatedSizeItem = (function (_super) {
        __extends(AnimatedSizeItem, _super);
        function AnimatedSizeItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.previousWidth = 0;
            _this.previousHeight = 0;
            _this.previousStyleWidth = "";
            _this.previousStyleHeight = "";
            _this.storeStyleSize = function (element) {
                _this.previousStyleWidth = element.style.width;
                _this.previousStyleHeight = element.style.height;
            };
            _this.restorePreviousStyleSize = function (element) {
                element.style.width = _this.previousStyleWidth;
                element.style.height = _this.previousStyleHeight;
            };
            _this.onEnter = function (element) {
                if (!_this.props.enter) {
                    return;
                }
                if (_this.props.onEnter) {
                    _this.props.onEnter();
                }
                var elementBounds = element.getBoundingClientRect();
                _this.previousWidth = elementBounds.width;
                _this.previousHeight = elementBounds.height;
            };
            _this.onEntering = function (element) {
                if (!_this.props.enter) {
                    return;
                }
                if (_this.props.onEntering) {
                    _this.props.onEntering();
                }
                _this.storeStyleSize(element);
                var elementBounds = element.getBoundingClientRect();
                if (elementBounds.width !== _this.previousWidth) {
                    element.style.width = _this.previousWidth + PIXELS_UNIT;
                }
                if (elementBounds.height !== _this.previousHeight) {
                    element.style.height = _this.previousHeight + PIXELS_UNIT;
                }
            };
            _this.onExit = function (element) {
                if (!_this.props.exit) {
                    return;
                }
                if (_this.props.onExit) {
                    _this.props.onExit();
                }
                _this.storeStyleSize(element);
                var elementBounds = element.getBoundingClientRect();
                element.style.width = elementBounds.width + PIXELS_UNIT;
                element.style.height = elementBounds.height + PIXELS_UNIT;
            };
            _this.onExiting = function (element) {
                if (!_this.props.exit) {
                    return;
                }
                if (_this.props.onExiting) {
                    _this.props.onExiting();
                }
                _this.restorePreviousStyleSize(element);
            };
            _this.onExited = function (element) {
                if (!_this.props.exit) {
                    return;
                }
                if (_this.props.onExited) {
                    _this.props.onExited();
                }
                _this.restorePreviousStyleSize(element);
            };
            return _this;
        }
        AnimatedSizeItem.prototype.render = function () {
            return (React__default['default'].createElement(reactTransitionGroup.CSSTransition, __assign({}, this.props, { onEnter: this.onEnter, onEntering: this.onEntering, onExit: this.onExit, onExiting: this.onExiting, onExited: this.onExited })));
        };
        return AnimatedSizeItem;
    }(React__default['default'].Component));

    var FLEXBOX_DISPLAY = document.createElement("p").style.flex === undefined ? "-webkit-flex" : "flex";
    var PIXEL_UNITS$1 = "px";
    var Spacer = (function (_super) {
        __extends(Spacer, _super);
        function Spacer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Spacer.prototype.render = function () {
            var FILL_SPACE = "100%";
            var style = {
                display: FLEXBOX_DISPLAY,
            };
            var _a = this.props, scrollDirection = _a.scrollDirection, dimension = _a.dimension, childKey = _a.childKey;
            if (scrollDirection === exports.ScrollExtensions.ScrollDirection.Horizontal) {
                style.width = dimension + PIXEL_UNITS$1;
                style.height = FILL_SPACE;
            }
            else if (scrollDirection === exports.ScrollExtensions.ScrollDirection.Vertical) {
                style.height = dimension + PIXEL_UNITS$1;
                style.width = FILL_SPACE;
            }
            return React__default['default'].createElement("script", { key: childKey, style: style });
        };
        return Spacer;
    }(React__default['default'].Component));

    var SCROLL_EVENT_NAME = "scroll";
    var RESIZE_EVENT_NAME = "resize";
    var PIXEL_UNITS = "px";
    var MIN_ITEM_SIZE = 10;
    var VirtualizedScrollViewer = (function (_super) {
        __extends(VirtualizedScrollViewer, _super);
        function VirtualizedScrollViewer(props, context) {
            var _a;
            var _this = _super.call(this, props, context) || this;
            _this.scrollDirection = exports.ScrollExtensions.ScrollDirection.Vertical;
            _this.hasPendingPropertiesUpdate = false;
            _this.pendingScrollAsyncUpdateHandle = 0;
            _this.isScrollOngoing = false;
            _this.isComponentInitialized = false;
            _this.enableFixStackDirection = false;
            _this._itemsStackVertically = true;
            _this.getScrollHostInfo = function () {
                if (!_this.scrollHostInfo) {
                    _this.scrollHostInfo = exports.ScrollExtensions.getScrollHostInfo(_this.itemsContainer);
                }
                return _this.scrollHostInfo;
            };
            _this.getScrollInfo = function () {
                var scrollHostInfo = _this.getScrollHostInfo();
                var scrollHost = scrollHostInfo.scrollHost;
                var scrollInfo = exports.ScrollExtensions.getScrollInfo(scrollHost);
                var result = {
                    scrollHost: scrollHost,
                    scrollOffset: scrollInfo ? _this.getDimension(scrollInfo.scroll.y, scrollInfo.scroll.x) : 0,
                    viewportSize: scrollInfo ? _this.getDimension(scrollInfo.viewport.height, scrollInfo.viewport.width) : 0,
                    viewportLowerBound: 0,
                    viewportUpperBound: 0,
                };
                if (scrollHost instanceof Window) {
                    result.viewportLowerBound = scrollInfo
                        ? _this.getDimension(scrollInfo.viewport.y, scrollInfo.viewport.x)
                        : 0;
                    result.viewportUpperBound = scrollInfo
                        ? _this.getDimension(scrollInfo.viewport.height, scrollInfo.viewport.width)
                        : 0;
                }
                else if (scrollHost instanceof HTMLElement) {
                    var bounds = scrollHost.getBoundingClientRect();
                    result.viewportLowerBound = _this.getDimension(bounds.top, bounds.left);
                    result.viewportUpperBound = _this.getDimension(bounds.bottom, bounds.right);
                }
                return result;
            };
            _this.addScrollHandler = function () {
                if (_this.isDisposed) {
                    return;
                }
                _this.scrollHostInfo = null;
                var scrollHostInfo = _this.getScrollHostInfo();
                var scrollHost = scrollHostInfo.scrollHost;
                scrollHost.addEventListener(SCROLL_EVENT_NAME, _this.onScroll);
                window.addEventListener(RESIZE_EVENT_NAME, _this.onScroll);
                _this.scrollDirection = scrollHostInfo.scrollDirection;
            };
            _this.removeScrollHandler = function () {
                var scrollHost = _this.getScrollHostInfo().scrollHost;
                scrollHost.removeEventListener(SCROLL_EVENT_NAME, _this.onScroll);
                window.removeEventListener(RESIZE_EVENT_NAME, _this.onScroll);
            };
            _this.onWindowScrollOrResize = function () {
                _this.removeWindowScrollHandlers();
                _this.addScrollHandler();
            };
            _this.removeWindowScrollHandlers = function () {
                window.removeEventListener(SCROLL_EVENT_NAME, _this.onWindowScrollOrResize, true);
                window.removeEventListener(RESIZE_EVENT_NAME, _this.onWindowScrollOrResize, true);
            };
            _this.renderOffScreenBuffer = function () {
                var _a;
                if (_this.scrollDirection !== exports.ScrollExtensions.ScrollDirection.Vertical) {
                    if (_this.state.offScreenItemsCount > 0) {
                        console.warn("Virtualization attempting offscreen items with horizontal stacking...");
                    }
                    return;
                }
                if (_this.itemsContainer) {
                    _this.itemsContainer.style.position = "relative";
                }
                var items = (_a = _this.itemsContainer) === null || _a === void 0 ? void 0 : _a.children;
                var itemsCount = _this.itemsContainer ? _this.itemsContainer.childElementCount : 0;
                var topPad = items === null || items === void 0 ? void 0 : items.item(0);
                var bottomPad = items === null || items === void 0 ? void 0 : items.item(itemsCount - 1);
                topPad.style.height = _this.state.scrollOffset + PIXEL_UNITS;
                bottomPad.style.height =
                    _this.getRemainingSize(_this.state.firstRenderedItemIndex, _this.state.lastRenderedItemIndex) + PIXEL_UNITS;
                for (var i = 1; i < _this.state.offScreenItemsCount + 1; i++) {
                    var child = items === null || items === void 0 ? void 0 : items.item(i);
                    if ((child === null || child === void 0 ? void 0 : child.style) !== undefined) {
                        if (!child.style.width) {
                            child.style.width = "100%";
                        }
                        child.style.position = "absolute";
                        child.style.top = "-10000" + PIXEL_UNITS;
                    }
                }
                for (var i = _this.state.offScreenItemsCount + 1; i < itemsCount - 1; i++) {
                    var child = items === null || items === void 0 ? void 0 : items.item(i);
                    if ((child === null || child === void 0 ? void 0 : child.style) !== undefined) {
                        child.style.position = "";
                        child.style.top = "";
                        child.style.width = "";
                    }
                }
            };
            _this.onScroll = function (scrollEvent) {
                if (_this.pendingScrollAsyncUpdateHandle) {
                    return;
                }
                _this.pendingScrollAsyncUpdateHandle = requestAnimationFrame(function () {
                    if (_this.isDisposed) {
                        return;
                    }
                    try {
                        var newState = _this.getCurrentScrollViewerState(_this.props.length, _this.state, _this.props, _this.itemsContainer, scrollEvent.type !== RESIZE_EVENT_NAME);
                        if (newState !== _this.state) {
                            _this.isScrollOngoing = true;
                            _this.setState(newState, function () { return (_this.isScrollOngoing = false); });
                        }
                    }
                    finally {
                        _this.pendingScrollAsyncUpdateHandle = 0;
                    }
                    if (_this.props.scrollChanged) {
                        _this.props.scrollChanged();
                    }
                });
            };
            _this.getRemainingSize = function (firstRenderedItemIndex, lastRenderedItemIndex) {
                var length = Math.min(_this.props.length, lastRenderedItemIndex - firstRenderedItemIndex + 1);
                var remainingSize = 0;
                var averageItemSize = Math.max(MIN_ITEM_SIZE, _this.state.averageItemSize);
                if (lastRenderedItemIndex < _this.props.length - 1) {
                    var scrollSize = averageItemSize * _this.props.length;
                    remainingSize =
                        scrollSize - (averageItemSize * (length - _this.state.offScreenItemsCount) + _this.state.scrollOffset);
                }
                return remainingSize;
            };
            _this.renderList = function (firstRenderedItemIndex, lastRenderedItemIndex) {
                var length = Math.min(_this.props.length, lastRenderedItemIndex - firstRenderedItemIndex + 1);
                var scrollOffset = _this.state.scrollOffset;
                var remainingSize = _this.getRemainingSize(firstRenderedItemIndex, lastRenderedItemIndex);
                var items = _this.props.renderItems(firstRenderedItemIndex, length);
                var averageItemSize = Math.max(MIN_ITEM_SIZE, _this.state.averageItemSize);
                var listChildren = [];
                if (_this.scrollDirection !== exports.ScrollExtensions.ScrollDirection.None) {
                    listChildren.push(_this.renderSpacer("first-spacer", scrollOffset, averageItemSize, function (spacer) { return (_this.firstSpacer = spacer); }));
                }
                if (items && items.length > 0) {
                    items.forEach(function (item) { return listChildren.push(item); });
                }
                else {
                    listChildren.push(items);
                }
                if (_this.scrollDirection !== exports.ScrollExtensions.ScrollDirection.None) {
                    listChildren.push(_this.renderSpacer("last-spacer", remainingSize, averageItemSize, function (spacer) { return (_this.lastSpacer = spacer); }));
                }
                return _this.props.renderWrapper(listChildren);
            };
            _this.renderSpacer = function (key, dimension, averageItemSize, storeRef) {
                return (React__namespace.createElement(Spacer, { key: key, childKey: key, dimension: dimension, averageItemSize: averageItemSize, scrollDirection: _this.scrollDirection, ref: function (spacer) { return storeRef(ReactDOM__namespace.findDOMNode(spacer)); } }));
            };
            _this.getListItems = function (itemsContainer) {
                var items = [];
                var children = itemsContainer.children;
                if (children.length > 0) {
                    var startIdx = _this.isSpacer(children[0]) ? 1 : 0;
                    var endIdx = _this.isSpacer(children[children.length - 1]) ? children.length - 2 : children.length - 1;
                    for (var i = startIdx; i <= endIdx; i++) {
                        var elem = itemsContainer.children[i];
                        items.push(elem);
                    }
                }
                return items;
            };
            _this.isSpacer = function (element) {
                return element === _this.firstSpacer || element === _this.lastSpacer;
            };
            _this.getItemBounds = function (item) {
                var bounds = item.getBoundingClientRect();
                var rect = {
                    width: bounds.width,
                    height: bounds.height,
                    left: bounds.left,
                    right: bounds.right,
                    top: bounds.top,
                    bottom: bounds.bottom,
                };
                if (_this.scrollDirection === exports.ScrollExtensions.ScrollDirection.Horizontal) {
                    if (rect.width < MIN_ITEM_SIZE) {
                        rect.width = MIN_ITEM_SIZE;
                        rect.right = rect.left + rect.width;
                    }
                }
                else if (_this.scrollDirection === exports.ScrollExtensions.ScrollDirection.Vertical) {
                    if (rect.height < MIN_ITEM_SIZE) {
                        rect.height = MIN_ITEM_SIZE;
                        rect.bottom = rect.top + rect.height;
                    }
                }
                return rect;
            };
            _this.areElementsStacked = function (items) {
                if (items.length < 2) {
                    return false;
                }
                var firstElement = items[items.length - 2];
                var secondElement = items[items.length - 1];
                var firstElementBounds = firstElement.getBoundingClientRect();
                var secondElementBounds = secondElement.getBoundingClientRect();
                return (Math.floor(_this.getDimension(secondElementBounds.top, 0)) >=
                    Math.floor(_this.getDimension(firstElementBounds.bottom, 1)));
            };
            _this.calculateItemsSize = function (items, firstItemIndex, lastItemIndex) {
                if (firstItemIndex === void 0) { firstItemIndex = 0; }
                if (lastItemIndex === void 0) { lastItemIndex = items.length - 1; }
                var total = 0;
                var sizes = new Array(lastItemIndex - firstItemIndex + 1);
                for (var i = firstItemIndex; i <= lastItemIndex; i++) {
                    var itemBounds = _this.getItemBounds(items[i]);
                    var size = _this.getDimension(itemBounds.height, itemBounds.width);
                    total += size;
                    sizes[i - firstItemIndex] = size;
                }
                return { total: total, sizes: sizes };
            };
            _this.countItemsAndSizeThatFitIn = function (itemsSizes, sizeToFit, allowOverflow, countBackwards) {
                if (allowOverflow === void 0) { allowOverflow = false; }
                if (countBackwards === void 0) { countBackwards = false; }
                var i = 0;
                var itemsSize = 0;
                var getIndex = countBackwards
                    ? function (idx) { return itemsSizes.length - 1 - idx; }
                    : function (idx) { return idx; };
                for (; i < itemsSizes.length; i++) {
                    var itemSize = itemsSizes[getIndex(i)];
                    if (itemsSize + itemSize > sizeToFit) {
                        if (allowOverflow) {
                            i++;
                            itemsSize += itemSize;
                        }
                        break;
                    }
                    itemsSize += itemSize;
                }
                return { size: itemsSize, count: i };
            };
            _this.getCurrentScrollViewerState = function (listLength, state, props, itemsContainer, returnSameStateOnSmallChanges) {
                var _a, _b;
                if (itemsContainer === void 0) { itemsContainer = _this.itemsContainer; }
                var scrollInfo = _this.getScrollInfo();
                var viewportSafetyMarginBefore = props.viewportSafetyMarginBefore || 7500;
                viewportSafetyMarginBefore = Math.min(scrollInfo.scrollOffset, viewportSafetyMarginBefore);
                var viewportSafetyMarginAfter = props.viewportSafetyMarginAfter || 7500;
                var forceRecalculate = false;
                if (scrollInfo.scrollOffset < scrollInfo.viewportSize / 4 &&
                    (state.firstRenderedItemIndex > 0 || state.offScreenItemsCount > 0)) {
                    forceRecalculate = true;
                }
                var items = itemsContainer ? _this.getListItems(itemsContainer) : [];
                if (items.length >= 2 && !(_this.itemsStackVertically && _this.areElementsStacked(items))) {
                    _this.scrollDirection = exports.ScrollExtensions.ScrollDirection.None;
                    if (_this.enableFixStackDirection) {
                        _this._itemsStackVertically = false;
                    }
                }
                if (_this.scrollDirection !== exports.ScrollExtensions.ScrollDirection.Vertical ||
                    items.length < 2) {
                    return {
                        firstRenderedItemIndex: 0,
                        lastRenderedItemIndex: Math.max(1, props.length - 1),
                        averageItemSize: 0,
                        scrollOffset: 0,
                        offScreenItemsCount: 0,
                        effectiveScrollOffset: scrollInfo.scrollOffset,
                    };
                }
                var lastSpacerBounds = (_a = itemsContainer === null || itemsContainer === void 0 ? void 0 : itemsContainer.lastElementChild) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                var spacerBoundsDimension = lastSpacerBounds
                    ? _this.getDimension(lastSpacerBounds.bottom, lastSpacerBounds.right)
                    : 0;
                if (spacerBoundsDimension < -100) {
                    return state;
                }
                var renderedItemsSizes = _this.calculateItemsSize(items);
                var offScreenItemsCount = state.offScreenItemsCount;
                var onScreenItems = renderedItemsSizes.sizes.slice(offScreenItemsCount);
                var onScreenItemsSize = onScreenItems.reduce(function (p, c) { return p + c; });
                var averageItemSize = onScreenItemsSize / (onScreenItems.length * 1.0);
                if (state.averageItemSize !== 0) {
                    averageItemSize = 0.8 * state.averageItemSize + 0.2 * averageItemSize;
                }
                var itemsFittingViewportCount = Math.ceil(scrollInfo.viewportSize / averageItemSize);
                var maxOffScreenItemsCount = itemsFittingViewportCount;
                var safetyItemsCountBefore = Math.ceil(viewportSafetyMarginBefore / averageItemSize);
                var safetyItemsCountAfter = Math.ceil(viewportSafetyMarginAfter / averageItemSize);
                var renderedItemsCountNew = Math.min(listLength, itemsFittingViewportCount + safetyItemsCountBefore + safetyItemsCountAfter + offScreenItemsCount);
                var scrollOffset = state.scrollOffset;
                var firstRenderedItemIndex = state.firstRenderedItemIndex;
                var viewportLowerMargin = scrollInfo.viewportLowerBound - viewportSafetyMarginBefore;
                var firstSpacerBounds = (_b = itemsContainer === null || itemsContainer === void 0 ? void 0 : itemsContainer.firstElementChild) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
                var firstItemOffset = firstSpacerBounds
                    ? _this.getDimension(firstSpacerBounds.bottom, firstSpacerBounds.right)
                    : 0;
                if (!forceRecalculate && Math.abs(firstItemOffset - viewportLowerMargin) <= onScreenItemsSize) {
                    if (firstItemOffset < viewportLowerMargin) {
                        var itemsGoingOffScreen = _this.countItemsAndSizeThatFitIn(onScreenItems, Math.abs(viewportLowerMargin - firstItemOffset));
                        if (itemsGoingOffScreen.count > 0) {
                            scrollOffset += itemsGoingOffScreen.size;
                            offScreenItemsCount += itemsGoingOffScreen.count;
                            if (offScreenItemsCount > maxOffScreenItemsCount) {
                                var leavingItemsCount = offScreenItemsCount - maxOffScreenItemsCount;
                                firstRenderedItemIndex += leavingItemsCount;
                                offScreenItemsCount = maxOffScreenItemsCount;
                            }
                        }
                    }
                    else if (firstItemOffset > viewportLowerMargin) {
                        var availableSpace = Math.abs(firstItemOffset - viewportLowerMargin);
                        var offScreenItems = renderedItemsSizes.sizes.slice(0, offScreenItemsCount);
                        var itemsGoingOnScreen = _this.countItemsAndSizeThatFitIn(offScreenItems, availableSpace, true, true);
                        if (itemsGoingOnScreen.count > 0) {
                            scrollOffset = Math.max(0, scrollOffset - itemsGoingOnScreen.size);
                            offScreenItemsCount -= itemsGoingOnScreen.count;
                            availableSpace -= itemsGoingOnScreen.size;
                        }
                        if (availableSpace > 0) {
                            if (offScreenItemsCount !== 0) {
                                throw "offScreenItemsCount should be 0";
                            }
                            var enteringItemsCount = Math.min(firstRenderedItemIndex, Math.ceil(availableSpace / averageItemSize));
                            firstRenderedItemIndex -= enteringItemsCount;
                            scrollOffset -= enteringItemsCount * averageItemSize;
                        }
                        if (offScreenItemsCount < maxOffScreenItemsCount) {
                            var enteringItemsCount = Math.min(firstRenderedItemIndex, maxOffScreenItemsCount - offScreenItemsCount);
                            firstRenderedItemIndex -= enteringItemsCount;
                            offScreenItemsCount += enteringItemsCount;
                        }
                    }
                }
                else {
                    var startOffset = firstSpacerBounds ? _this.getDimension(firstSpacerBounds.top, firstSpacerBounds.left) : 0;
                    if (startOffset < scrollInfo.viewportLowerBound) {
                        startOffset = Math.abs(startOffset - scrollInfo.viewportLowerBound);
                    }
                    else {
                        startOffset = 0;
                    }
                    firstRenderedItemIndex = Math.max(0, Math.floor(startOffset / averageItemSize) - 1);
                    offScreenItemsCount = 0;
                    if (firstRenderedItemIndex > 0) {
                        firstRenderedItemIndex = Math.max(0, firstRenderedItemIndex - Math.ceil(viewportSafetyMarginBefore / averageItemSize));
                    }
                    firstRenderedItemIndex = Math.max(0, Math.min(firstRenderedItemIndex, listLength - 1 - renderedItemsCountNew));
                    scrollOffset = firstRenderedItemIndex * averageItemSize;
                }
                if (firstRenderedItemIndex === 0 && offScreenItemsCount === 0) {
                    scrollOffset = 0;
                }
                var beforeCount = Math.max(Math.ceil(scrollOffset / averageItemSize), 0);
                var newRenderedItemsCountNew = Math.min(listLength, itemsFittingViewportCount +
                    Math.min(safetyItemsCountBefore, beforeCount) +
                    safetyItemsCountAfter +
                    offScreenItemsCount);
                var lastRenderedItemIndex = Math.min(listLength - 1, firstRenderedItemIndex + newRenderedItemsCountNew);
                return {
                    firstRenderedItemIndex: firstRenderedItemIndex,
                    lastRenderedItemIndex: lastRenderedItemIndex,
                    averageItemSize: averageItemSize,
                    scrollOffset: scrollOffset,
                    offScreenItemsCount: offScreenItemsCount,
                    effectiveScrollOffset: scrollInfo.scrollOffset,
                };
            };
            _this.scrollToIndex = function (index) {
                _this.internalSetScrollOffset(function () {
                    var scrollInfo = _this.getScrollInfo();
                    var scrollHost = scrollInfo.scrollHost;
                    var scrollOffset = _this.state.averageItemSize * index;
                    var firstVisibleItemOffset = scrollInfo.scrollOffset;
                    var needsScroll = false;
                    if (scrollOffset < firstVisibleItemOffset) {
                        needsScroll = true;
                    }
                    else {
                        var lastVisibleItemOffset = firstVisibleItemOffset + scrollInfo.viewportSize - _this.state.averageItemSize;
                        if (scrollOffset > lastVisibleItemOffset) {
                            scrollOffset = scrollOffset - (lastVisibleItemOffset - firstVisibleItemOffset);
                            needsScroll = true;
                        }
                    }
                    if (!needsScroll) {
                        return;
                    }
                    var scrollX = _this.getDimension(0, scrollOffset);
                    var scrollY = _this.getDimension(scrollOffset, 0);
                    exports.ScrollExtensions.setScrollOffset(scrollHost, scrollX, scrollY, false);
                });
            };
            _this.scrollToOffset = function (x, y) {
                _this.internalSetScrollOffset(function () {
                    var scrollInfo = _this.getScrollInfo();
                    var scrollHost = scrollInfo.scrollHost;
                    var scrollX = _this.getDimension(0, x);
                    var scrollY = _this.getDimension(y, 0);
                    exports.ScrollExtensions.setScrollOffset(scrollHost, scrollX, scrollY);
                });
            };
            _this.setScrollOffset = _this.scrollToOffset;
            _this.internalSetScrollOffset = function (setScroll) {
                if (_this.isInitialized) {
                    setScroll();
                }
                else {
                    _this.setPendingScroll = setScroll;
                }
            };
            _this.state = {
                firstRenderedItemIndex: 0,
                lastRenderedItemIndex: 1,
                averageItemSize: 0,
                scrollOffset: 0,
                offScreenItemsCount: 0,
                effectiveScrollOffset: Number.MIN_VALUE,
            };
            _this.scrollHostInfo = null;
            _this.itemsContainer = null;
            _this.setPendingScroll = null;
            _this.firstSpacer = null;
            _this.lastSpacer = null;
            _this.enableFixStackDirection = (_a = props.enableFixStackDirection) !== null && _a !== void 0 ? _a : false;
            return _this;
        }
        Object.defineProperty(VirtualizedScrollViewer.prototype, "itemsStackVertically", {
            get: function () {
                return this._itemsStackVertically;
            },
            enumerable: false,
            configurable: true
        });
        VirtualizedScrollViewer.prototype.componentDidMount = function () {
            var _this = this;
            this.itemsContainer = ReactDOM__namespace.findDOMNode(this);
            requestAnimationFrame(function () {
                if (!_this.isDisposed) {
                    window.addEventListener(SCROLL_EVENT_NAME, _this.onWindowScrollOrResize, true);
                    window.addEventListener(RESIZE_EVENT_NAME, _this.onWindowScrollOrResize, true);
                }
            });
            this.setState(this.getCurrentScrollViewerState(this.props.length, this.state, this.props));
        };
        VirtualizedScrollViewer.prototype.componentWillUnmount = function () {
            this.removeWindowScrollHandlers();
            this.removeScrollHandler();
            this.scrollHostInfo = null;
            this.itemsContainer = null;
        };
        VirtualizedScrollViewer.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            this.setState(this.getCurrentScrollViewerState(nextProps.length, this.state, this.props));
            this.hasPendingPropertiesUpdate = true;
        };
        VirtualizedScrollViewer.prototype.setState = function (state, callback) {
            var _this = this;
            _super.prototype.setState.call(this, state, function () {
                _this.onDidUpdate();
                if (callback) {
                    callback();
                }
            });
        };
        VirtualizedScrollViewer.prototype.onDidUpdate = function () {
            var _this = this;
            this.itemsContainer = ReactDOM__namespace.findDOMNode(this);
            this.renderOffScreenBuffer();
            if (this.setPendingScroll) {
                requestAnimationFrame(function () {
                    if (!_this.isDisposed && _this.setPendingScroll) {
                        _this.setPendingScroll();
                        _this.setPendingScroll = null;
                    }
                });
            }
            if (!this.isComponentInitialized) {
                this.isComponentInitialized = true;
                if (this.props.initializationCompleted) {
                    this.props.initializationCompleted();
                }
            }
            if (this.hasPendingPropertiesUpdate) {
                this.hasPendingPropertiesUpdate = false;
                this.setState(this.getCurrentScrollViewerState(this.props.length, this.state, this.props));
            }
        };
        VirtualizedScrollViewer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
            return (nextState.firstRenderedItemIndex !== this.state.firstRenderedItemIndex ||
                nextState.lastRenderedItemIndex !== this.state.lastRenderedItemIndex ||
                nextState.scrollOffset !== this.state.scrollOffset ||
                nextProps !== this.props);
        };
        VirtualizedScrollViewer.prototype.render = function () {
            return this.renderList(this.state.firstRenderedItemIndex, this.state.lastRenderedItemIndex);
        };
        VirtualizedScrollViewer.prototype.getDimension = function (vertical, horizontal) {
            return this.scrollDirection === exports.ScrollExtensions.ScrollDirection.Vertical ? vertical : horizontal;
        };
        Object.defineProperty(VirtualizedScrollViewer.prototype, "isScrolling", {
            get: function () {
                return this.isScrollOngoing;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(VirtualizedScrollViewer.prototype, "isInitialized", {
            get: function () {
                return this.isComponentInitialized;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(VirtualizedScrollViewer.prototype, "isDisposed", {
            get: function () {
                return !this.itemsContainer;
            },
            enumerable: false,
            configurable: true
        });
        return VirtualizedScrollViewer;
    }(React__namespace.Component));

    var SCROLL_VIEWER_COMPONENT_REF = "scrollViewer";
    var VirtualizedList = (function (_super) {
        __extends(VirtualizedList, _super);
        function VirtualizedList() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        VirtualizedList.prototype.renderItem = function (index) {
            var even = index % 2 === 0;
            var className = "list-item " + (even ? "even" : "odd");
            var item = this.props.list[index];
            return (React__namespace.createElement("div", { key: "i-" + index, className: className },
                "Item ",
                item.index,
                React__namespace.createElement("img", { src: item.image })));
        };
        VirtualizedList.prototype.componentDidMount = function () {
            this.getScrollViewer().scrollToOffset(0, 1000);
        };
        VirtualizedList.prototype.renderItems = function (startIndex, length) {
            var items = [];
            for (var i = startIndex; i < startIndex + length; i++) {
                items.push(this.renderItem(i));
            }
            return items;
        };
        VirtualizedList.prototype.getScrollViewer = function () {
            return this.refs[SCROLL_VIEWER_COMPONENT_REF];
        };
        Object.defineProperty(VirtualizedList.prototype, "shouldSuspendAnimations", {
            get: function () {
                var scrollViewer = this.getScrollViewer();
                return !scrollViewer || !scrollViewer.isInitialized || scrollViewer.isScrolling;
            },
            enumerable: false,
            configurable: true
        });
        VirtualizedList.prototype.createScrollViewerContainer = function (children) {
            var _this = this;
            var listAttributes = {
                className: "list",
                component: "div",
                shouldSuspendAnimations: function () { return _this.shouldSuspendAnimations; },
                transitionName: "example",
            };
            return React__namespace.createElement(AnimatedSizeGroup, listAttributes, children);
        };
        VirtualizedList.prototype.render = function () {
            var _this = this;
            return (React__namespace.createElement(VirtualizedScrollViewer, { renderItems: function (start, length) { return _this.renderItems(start, length); }, renderWrapper: function (children) { return _this.createScrollViewerContainer(children); }, length: this.props.list.length, pageBufferSize: this.props.pageBufferSize, ref: SCROLL_VIEWER_COMPONENT_REF }));
        };
        VirtualizedList.prototype.scrollToOffset = function (offset) {
            this.getScrollViewer().scrollToOffset(0, offset);
        };
        VirtualizedList.prototype.scrollToIndex = function (index) {
            this.getScrollViewer().scrollToIndex(index);
        };
        return VirtualizedList;
    }(React__namespace.Component));

    exports.AnimatedGroup = AnimatedGroup;
    exports.AnimatedSizeGroup = AnimatedSizeGroup;
    exports.Spacer = Spacer;
    exports.VirtualizedList = VirtualizedList;
    exports.VirtualizedScrollViewer = VirtualizedScrollViewer;

    Object.defineProperty(exports, '__esModule', { value: true });

});

